import SodApplicationGroup from './SodApplicationGroup';

export default SodApplicationGroup;
